module.exports = __webpack_public_path__ + "static/media/ups-logo-grey.a1f45629.png";